import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'release-notes-dialog',
  templateUrl: 'release-notes-dialog.component.html',
  styleUrls: ['release-notes-dialog.component.scss'],
  standalone: false,
})
export class ReleaseNotesDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ReleaseNotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {}

  onClickClose(): void {
    this.dialogRef.close();
  }
}
